// extracted by mini-css-extract-plugin
export default {"fileClaimButton":"FileClaimButton_fileClaimButton__0Pd3O"};